<template>
  <div class="body-wrapper" ref="workouts">
    <Header :title="'WORKOUTS'" />
    
    <div class="extra-options">
      <button class="secondary-btn-dark" @click="createWorkoutClicked()">CREATE NEW WORKOUT</button>
    </div>

    <div class="workout-wizard">
      <div class="step step-1">
        <div 
          class="placeholder-row workout-row"
          :id="selectedPlaceholder() ? 'active' : ''"
          @click="selectPlaceholder()">
          <div class="row-image">
            <img src="../assets/workout_placeholder_icon.png" />
          </div>
          <div class="row-details">
            <h3>PLACEHOLDER WORKOUT TYPE IMAGES</h3>
            <p>User created workout placeholder images based on the workout types, if the user has not added an image.</p>
          </div>
        </div>

        <div class="workout-row" 
          v-for="workout in workouts" 
          @click="selectWorkout(workout)" 
          :key="workout.id" 
          :id="selectedWorkout(workout.id) ? 'active' : ''">
          <div class="row-image">
            <img v-if="workout.image" :src="url + workout.image" />
            <img v-else src="../assets/workout_no_image.png" />
          </div>
          <div class="row-details">
            <h3>{{workout.title}}</h3>
            <p>{{workout.description}}</p>
            <div class="workout-extras">
              <span>{{getWorkoutType(workout.workout_type)}}</span>
              <span>{{getDurationType(workout.workout_duration)}}</span>
              <span>{{workout.published ? 'PUBLISHED' : ''}}</span>
            </div>
          </div>
          <div class="pro-triangle" v-if="workout.premium_type == 'pro'">
            <img v-if="selectedWorkout(workout.id)" src="../assets/pro_workout_selected.png" />
            <img v-else src="../assets/pro_workout_unselected.png" />
          </div>
        </div>
      </div>
      <div class="step step-2" v-if="createWorkout || currentWorkout.id">
        <div class="workout-header">
          <div class="left">
            <div class="attribute">
              <span>Workout Title</span>
              <input
                type="text" 
                v-model="workoutTitle"
                :class="{ error: errors.title }"/>
            </div>
            <div class="attribute">
              <span>Workout Description</span>
              <textarea
                v-model="workoutDescription"
                :class="{ error: errors.description }"></textarea>
            </div>
            <div class="attribute-row">
              <div class="attribute">
                <span>Type</span>
                <select
                  v-model="workoutType"
                  :class="{ error: errors.workoutType }">
                  <option value="">Select a type</option>
                  <option value="push">Push Workout</option>
                  <option value="pull">Pull Workout</option>
                  <option value="legs">Legs Workout</option>
                  <option value="fullbody">Fullbody Workout</option>
                </select>
              </div>
              <div class="attribute">
                <span>Time Estimate</span>
                <select
                  v-model="workoutDuration"
                  :class="{ error: errors.workoutDuration }">
                  <option value="">Select a duration</option>
                  <option value="15-30m">15 - 30 mins</option>
                  <option value="30-45m">30 - 45 mins</option>
                  <option value="45-1hr">45 - 1hr</option>
                  <option value="1hr+">1hr +</option>
                  <option value="1-1.5hr">1 - 1.5hr</option>
                  <option value="1.5-2hr">1.5 - 2hr</option>
                  <option value="2hr+">2hr +</option>
                </select>
              </div>
            </div>
            <div class="attribute-row bottom-row">
              <a @click="removeWorkout()"><i class="fas fa-trash"></i></a>
              <div class="spacer"></div>
              <span>Pro:</span>
              <ToggleButton
                @change="togglePro()"
                :value="workoutPro" />
              <span>Published:</span>
              <ToggleButton
                @change="togglePublished()"
                :value="workoutPublished" />
            </div>
          </div>
          <div class="right">
            <form enctype="multipart/form-data" novalidate>
              <div class="dropbox default" :class="{'error': errors.workoutImage}">
                <input
                  type="file"
                  @change="
                    filesChange($event.target.files);
                    fileCount = $event.target.files.length;
                  "
                  accept="image/*"
                  class="input-file"
                />
                <img v-if="previewUrl != ''" id="preview" :src="previewUrl" />
                <img class="default-img" v-if="previewUrl == ''" id="preview" src="../assets/workout_no_image.png" />
              </div>            
            </form>
            <a @click="deleteImage()"><i class="fas fa-times"></i></a>
            <div class="spacer"></div>
            <button class="primary-btn" @click="saveWorkout()">SAVE WORKOUT</button>
          </div>
        </div>
        <div class="workout-body">
          <div class="exercise-search">
            <div class="row">
              <p>Add Exercise:</p>
              <p>Exercise: {{workoutActivities.length}}</p>
            </div>
            <div class="search-box">
              <input type="text" v-model="exerciseSearch" @keyup="searchForExercise()" @focus="resultVisible = true;">
              <div class="results" v-if="resultVisible">
                <p 
                  v-bind:key="exercise.id"
                  @click="addExercise(exercise)"
                  v-for="exercise in exercisesResponse">{{exercise.title}} - {{exercise.equipment}}</p>
              </div>
            </div>
          </div>
          <div class="exercise-row" :key="exercise.id" v-for="exercise in workoutActivities">
            <h3>{{exercise.exercises[0].title}} - {{exercise.exercises[0].equipment}}</h3>
            <div class="details-row">
              <div class="details">
                <p>Sets:</p>
                <input type="text" v-model="exercise.setCount">
              </div>
              <div class="details">
                <p>Reps:</p>
                <input type="text" v-model="exercise.preview_sets[0].reps">
              </div>
              <div class="details">
                <p>Effort:</p>
                <select v-model="exercise.preview_sets[0].difficulty_type">
                  <option value="focus">Focus on form throughout</option>
                    <option value="failure">Go to failure on each set</option>
                    <option value="max">Work up to 1 rep max</option>
                    <option value="last">Last rep should be very hard</option>
                    <option value="<5">&#60; 5 Rating of perceived exertion</option>
                    <option value="5">5/10 Rating of perceived exertion</option>
                    <option value="6">6/10 Rating of perceived exertion</option>
                    <option value="7">7/10 Rating of perceived exertion</option>
                    <option value="8">8/10 Rating of perceived exertion</option>
                    <option value="9">9/10 Rating of perceived exertion</option>
                    <option value="10">10/10 Rating of perceived exertion</option>
                </select>
              </div>
              <a @click="removeExercise(exercise.id)"><i class="fas fa-trash"></i></a>
              <a @click="exerciseMove(exercise.id, -1)"><i class="fas fa-arrow-alt-circle-up"></i></a>
              <a @click="exerciseMove(exercise.id, 1)"><i class="fas fa-arrow-alt-circle-down"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="step step-2" v-if="editPlaceholderImages">
        <div class="image-row">
          <div class="image-holder">
            <div class="image-header">
              <p>Push Image</p>
              <i class="fas fa-times"></i>
            </div>
            <div class="image-body">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox default" :class="{'error': errors.pushImage}">
                  <input
                    type="file"
                    @change="
                      placeholderFileChange('push', $event.target.files);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <img v-if="pushPreviewUrl != ''" id="preview" :src="pushPreviewUrl" />
                  <img class="default-img" v-if="pushPreviewUrl == ''" id="preview" src="../assets/workout_no_image.png" />
                </div>            
              </form>
            </div>
          </div>
          <div class="image-holder">
            <div class="image-header">
              <p>Pull Image</p>
              <i class="fas fa-times"></i>
            </div>
            <div class="image-body">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox default" :class="{'error': errors.pullImage}">
                  <input
                    type="file"
                    @change="
                      placeholderFileChange('pull', $event.target.files);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <img v-if="pullPreviewUrl != ''" id="preview" :src="pullPreviewUrl" />
                  <img class="default-img" v-if="pullPreviewUrl == ''" id="preview" src="../assets/workout_no_image.png" />
                </div>            
              </form>
            </div>
          </div>
        </div>
        <div class="image-row">
          <div class="image-holder">
            <div class="image-header">
              <p>Legs Image</p>
              <i class="fas fa-times"></i>
            </div>
            <div class="image-body">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox default" :class="{'error': errors.legsImage}">
                  <input
                    type="file"
                    @change="
                      placeholderFileChange('legs', $event.target.files);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <img v-if="legsPreviewUrl != ''" id="preview" :src="legsPreviewUrl" />
                  <img class="default-img" v-if="legsPreviewUrl == ''" id="preview" src="../assets/workout_no_image.png" />
                </div>            
              </form>
            </div>
          </div>
          <div class="image-holder">
            <div class="image-header">
              <p>Fullbody Image</p>
              <i class="fas fa-times"></i>
            </div>
            <div class="image-body">
              <form enctype="multipart/form-data" novalidate>
                <div class="dropbox default" :class="{'error': errors.fullbodyImage}">
                  <input
                    type="file"
                    @change="
                      placeholderFileChange('fullbody', $event.target.files);
                      fileCount = $event.target.files.length;
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <img v-if="fullbodyPreviewUrl != ''" id="preview" :src="fullbodyPreviewUrl" />
                  <img class="default-img" v-if="fullbodyPreviewUrl == ''" id="preview" src="../assets/workout_no_image.png" />
                </div>            
              </form>
            </div>
          </div>
        </div>
        <div class="image-actions">
          <button class="primary-btn" @click="savePlaceholderImages()">SAVE</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { 
  createWorkout,
  updateWorkout,
  deleteWorkout,
  getExercises,
  saveExerciseAndReps,
  saveWorkoutPlaceholderImages,
  getPublicWorkouts,
  getPublicWorkoutDetails,
} from '@/api/requests';
import Header from "@/components/header/Header";
import { debounce } from "debounce";

export default {
  name: 'Workouts',

  data () {
    return {
      previewUrl: '',
      imageToUpload: [],
      workoutTitle: "",
      workoutDescription: "",
      workoutType: "",
      workoutDuration: "",
      workoutPro: false,
      workoutPublished: false,
      workoutDeleteImage: false,
      workoutActivities: [],
      load: 0,
      loading: false,
      maxLoaded: false,

      exerciseSearch: "",
      resultVisible: false,
      exercisesResponse: [],

      pushPreviewUrl: "",
      pushImageToUpload: [],
      pullPreviewUrl: "",
      pullImageToUpload: [],
      legsPreviewUrl: "",
      legsImageToUpload: [],
      fullbodyPreviewUrl: "",
      fullbodyImageToUpload: [],

      errors: {
        workoutImage: false,
        workoutTitle: false,
        workoutDescription: false,
        workoutType: false,
        workoutDuration: false,

        pushImage: false,
        pullImage: false,
        legsImage: false,
        fullbodyImage: false,
      }
    };
  },

  components: {
    Header,
    ToggleButton,
  },

  mounted() {
    this.$store.dispatch('workouts/loadPlaceholderImages');

    this.loadWorkouts();

    this.$refs.workouts.addEventListener(
      "scroll",
      this.handleScroll
    );
  },

  methods: {
    loadWorkouts() {
      if (!this.maxLoaded && !this.loading) {
        this.loading = true;
        const params = {
          'offset': this.load,
        }
        getPublicWorkouts(params).then(response => {
          this.maxLoaded = response.data.data.length < 16;
          if (this.load > 0) {
            this.$store.commit('workouts/loadMore', response.data.data);
          } else {
            this.$store.commit('workouts/setOriginalValue', response.data.data);
          }
        }).catch(() => {
          // TODO errors
        }).finally(() => {
          this.loading = false;
        });
      }
    },

    handleScroll(event) {
      if (!this.maxLoaded && !this.loading) {
        let { scrollTop, scrollHeight, clientHeight } = event.target;
        const offsetForTrigger = 450;
  
        if (scrollHeight - clientHeight - offsetForTrigger < scrollTop) {
          this.load++;
          this.loadWorkouts();
        }
      }
    },

    resetValues() {
      this.previewUrl = '';
      this.imageToUpload = [];
      this.workoutTitle = "";
      this.workoutDescription = "";
      this.workoutType = "";
      this.workoutDuration = "";
      this.workoutPro = false;
      this.workoutPublished = false;
      this.workoutDeleteImage = false;
      this.workoutActivities = [];
    },
    
    selectPlaceholder() {
      this.$store.dispatch('workouts/placeholderImagesClicked');
      this.pushPreviewUrl = this.$store.state.workouts.pushPlaceholder ? this.url + this.$store.state.workouts.pushPlaceholder : '';
      this.pullPreviewUrl = this.$store.state.workouts.pullPlaceholder ? this.url + this.$store.state.workouts.pullPlaceholder : '';
      this.legsPreviewUrl = this.$store.state.workouts.legsPlaceholder ? this.url + this.$store.state.workouts.legsPlaceholder : '';
      this.fullbodyPreviewUrl = this.$store.state.workouts.fullbodyPlaceholder ? this.url + this.$store.state.workouts.fullbodyPlaceholder : '';
      this.createWorkout = false;
      this.resetValues();
    },

    selectWorkout(selectedWorkout) {
      getPublicWorkoutDetails(selectedWorkout.id).then(response => {
        this.$store.dispatch('workouts/workoutClicked', response.data.data);
        this.workoutTitle = selectedWorkout.title;
        this.workoutDescription = selectedWorkout.description;
        this.workoutType = selectedWorkout.workout_type || "";
        this.workoutDuration = selectedWorkout.workout_duration || "";
        this.workoutPro = selectedWorkout.premium_type == "pro";
        this.workoutPublished = selectedWorkout.published || false;
        this.previewUrl = selectedWorkout.image !== "" ? this.url + selectedWorkout.image : "";
        this.workoutActivities = [];
        if (this.$store.state.workouts.selectedWorkout.workout_activities) {
          this.workoutActivities = this.$store.state.workouts.selectedWorkout.workout_activities;
          if (!Array.isArray(this.workoutActivities)) {
            this.workoutActivities = JSON.parse(this.$store.state.workouts.selectedWorkout.workout_activities);
          }
          this.workoutActivities.forEach(act => {
            act['setCount'] = act.preview_sets ? act.preview_sets.length : 0;
          })
        }
      }).catch(() => {
        // TODO errors
      }).finally(() => {
        this.loading = false;
      });

    },

    selectedWorkout(id) {
      return this.$store.state.workouts.selectedWorkout?.id === id;
    },

    selectedPlaceholder() {
      return this.$store.state.workouts.selectedPlaceholder;
    },

    filesChange(fileList) {
      this.previewUrl = URL.createObjectURL(fileList[0]);
      this.imageToUpload = [fileList[0]];
      this.workoutDeleteImage = false;
    },

    placeholderFileChange(type, fileList) {
      if (type === 'pull') {
        this.pullPreviewUrl = URL.createObjectURL(fileList[0]);
        this.pullImageToUpload = [fileList[0]];
      } else if (type == 'push') {
        this.pushPreviewUrl = URL.createObjectURL(fileList[0]);
        this.pushImageToUpload = [fileList[0]];
      } else if (type == 'legs') {
        this.legsPreviewUrl = URL.createObjectURL(fileList[0]);
        this.legsImageToUpload = [fileList[0]];     
      } else if (type == 'fullbody') {
        this.fullbodyPreviewUrl = URL.createObjectURL(fileList[0]);
        this.fullbodyImageToUpload = [fileList[0]];
      }
    },

    savePlaceholderImages() {
      let formData = new FormData();
      if (this.pullImageToUpload.length) {
        formData.append(
          "pull_image",
          this.pullImageToUpload[0],
          this.pullImageToUpload[0].name
        );
      }
      if (this.pushImageToUpload.length) {
        formData.append(
          "push_image",
          this.pushImageToUpload[0],
          this.pushImageToUpload[0].name
        );
      }
      if (this.legsImageToUpload.length) {
        formData.append(
          "legs_image",
          this.legsImageToUpload[0],
          this.legsImageToUpload[0].name
        );
      }
      if (this.fullbodyImageToUpload.length) {
        formData.append(
          "fullbody_image",
          this.fullbodyImageToUpload[0],
          this.fullbodyImageToUpload[0].name
        );
      }

      saveWorkoutPlaceholderImages(formData).then((response) => {
        this.$toasted.global.app_success({
          message: "Images updated."
        });      })
      .catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update images."
        });
      });
    },

    togglePro() {
      this.workoutPro = !this.workoutPro;
    },

    togglePublished() {
      this.workoutPublished = !this.workoutPublished;
    },

    getExerciseDetails() {
      let exerciseDetails = [];
      this.workoutActivities.forEach(workoutExercise => {
        exerciseDetails.push({
          'exercises': workoutExercise.exercises.map(ex => ex.id),
          'sets': this.getSetDetails(workoutExercise.preview_sets[0], workoutExercise.setCount)
        })
      });

      return exerciseDetails;
    },

    getSetDetails(firstSet, count) {
      let setDetails = [];

      for (let i = 0; i < count; i++) {
        setDetails.push({
          'set_number': "1",
          'superset_letter': "",
          'parent_set_number': "",
          'reps': firstSet.reps,
          'superset': false,
          'exercise_type': firstSet.exercise_type,
          'difficulty_type': firstSet.difficulty_type,
          'custom_difficulty': firstSet.custom_difficulty,
        });
      }

      return setDetails;
    },

    saveWorkout() {
      if (this.validateWorkout()) {
        let userPayload = {
          title: this.workoutTitle,
          description: this.workoutDescription,
          premium_type: this.workoutPro ? 'pro' : 'basic',
          workout_type: this.workoutType,
          workout_duration: this.workoutDuration,
          published: this.workoutPublished,
        };

        let formData = new FormData();
        for (var key in userPayload) {
          formData.append(key, userPayload[key]);
        }
        if (this.imageToUpload.length) {
          formData.append(
            "image",
            this.imageToUpload[0],
            this.imageToUpload[0].name
          );
        }

        if (this.createWorkout) {
          createWorkout(formData).then((response) => {
            this.saveExerciseReps(response.data.id);
          })
          .catch(() => {
            this.$toasted.global.app_error({
              message: "Failed to create workout."
            });
          });
        } else {
          updateWorkout(this.currentWorkout.id, formData).then((response) => {
            this.saveExerciseReps(this.currentWorkout.id);
          })
          .catch((e) => {
            this.$toasted.global.app_error({
              message: "Failed to update workout."
            });
          });

        }
      }
    },

    saveExerciseReps(id) {
      const payload = {
        exercises: this.getExerciseDetails(),
      };

      saveExerciseAndReps(id, payload).then((response) => {
        this.$store.dispatch('workouts/clearWorkouts');
        this.$store.dispatch('workouts/loadWorkouts');
        this.$toasted.global.app_success({
          message: "Workout has been created."
        });
      })
      .catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update exercises and sets."
        });
      });
    },

    validateWorkout() {
      this.errors = {
        workoutImage: false,
        workoutTitle: false,
        workoutDescription: false,
        workoutType: false,
        workoutDuration: false,
      };
      let valid = true;
      if (this.imageToUpload.length == 0 && !this.previewUrl) {
        this.errors.workoutImage = true;
        valid = false;
      }
      if (this.workoutTitle == "") {
        this.errors.workoutTitle = true;
        valid = false;
      }
      if (this.workoutDescription == "") {
        this.errors.workoutDescription = true;
        valid = false;
      }
      if (this.workoutType == "") {
        this.errors.workoutType = true;
        valid = false;
      }
      if (this.workoutDuration == "") {
        this.errors.workoutDuration = true;
        valid = false;
      }
      if (this.workoutActivities.length < 1) {
        valid = false;
      } else {
        this.workoutActivities.forEach(activity => {
          if (activity.preview_sets[0].reps == 0) {
            valid = false;
          }
          if (activity.setCount == 0) {
            valid = false;
          }
        });
      }

      return valid;
    },

    removeWorkout() {
      if (this.createWorkout) {
        this.$store.dispatch('workouts/cancelWorkoutModify');
      } else {
        this.$confirm(
        "Are you sure you want to delete this workout?", 
        "DELETE WORKOUT").then(() => {
          deleteWorkout(this.currentWorkout.id).then((response) => {
            this.$store.commit('workouts/removeWorkout', this.currentWorkout.id);
            this.$store.dispatch('workouts/cancelWorkoutModify');
            this.$toasted.global.app_success({
              message: "Workout has been deleted."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to delete workout."
          });
        });
      }
    },

    deleteImage() {
      if (this.createWorkout) {
        this.previewUrl = '';
        this.imageToUpload = [];
      } else {
        this.workoutDeleteImage = true;
        this.previewUrl = '';
        this.imageToUpload = [];
      }
    },

    searchForExercise: debounce(function (e) {
      const payload = {
        offset: 0,
        search: this.exerciseSearch,
        only_workouts: true,
        only_official: true,
      };

      getExercises(payload).then((response) => {
        this.exercisesResponse = response.data['exercises'];
      });
    }, 400),

    addExercise(ex) {
      this.resultVisible = false;
      this.workoutActivities.push({
        id: Math.floor(Math.random() * 1000),
        exercises: [ex],
        setCount: 1,
        preview_sets: [{
          custom_difficulty: null,
          difficulty_type: "focus",
          reps: 0,
        }]
      })
    },

    removeExercise(exerciseId) {
      let exercise = this.workoutActivities.find(e => e.id === exerciseId);
      let index = this.workoutActivities.indexOf(exercise);
      this.workoutActivities.splice(index, 1);
    },

    exerciseMove(exerciseId, change) {
      let exercise = this.workoutActivities.find(e => e.id === exerciseId);
      let oldIndex = this.workoutActivities.indexOf(exercise);
      while (oldIndex < 0) {
          oldIndex += this.workoutActivities.length;
      }
      let newIndex = oldIndex + change;
      while (newIndex < 0) {
          newIndex += this.workoutActivities.length;
      }
      
      if (newIndex >= this.workoutActivities.length) {
        newIndex = 0;
      }

      this.workoutActivities.splice(newIndex, 0, this.workoutActivities.splice(oldIndex, 1)[0]);
    },

    getWorkoutType(type) {
      switch(type) {
        case "push":
          return "PUSH WORKOUT";
        case "pull":
          return "PULL WORKOUT";
        case "legs":
          return "LEGS WORKOUT";
        case "fullbody":
          return "FULLBODY WORKOUT";
      }
    },

    getDurationType(type) {
      switch(type) {
        case '15-30m':
          return "15 - 30 mins"
        case '30-45m':
          return "30 - 45 mins"
        case '45-1hr':
          return "45 - 1hr"
        case '1hr+':
          return "1hr +"
        case '1-1.5hr':
          return "1 - 1.5hr"
        case '1.5-2hr':
          return "1.5 - 2hr"
        case '2hr+':
          return "2hr +"
      }
    },

    createWorkoutClicked() {
      this.$store.dispatch('workouts/newWorkoutClicked');
      this.createWorkout = true;
      this.resetValues();
    }
  },

  computed: {
    workouts() {
      return this.$store.state.workouts.workouts;
    },

    currentWorkout() {
      return this.$store.state.workouts.selectedWorkout;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    createWorkout: {
      get () {
        return this.$store.state.workouts.createWorkout
      },
      set (value) {
        this.$store.commit('workouts/updateAttribute', {value: value, type: 'createWorkout'})
      }
    },

    editPlaceholderImages: {
      get () {
        return this.$store.state.workouts.selectedPlaceholder
      },
      set (value) {
        this.$store.commit('workouts/updateAttribute', {value: value, type: 'selectedPlaceholder'})
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
$secondary-grey: #333546;

.body-wrapper {
  height: 100vh;
  overflow: auto;
}

.dropbox {
  background: $sec0;
  border-radius: 0;
  width: 200px;
  height: 157px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  #preview {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  
}

.extra-options {
  display: flex;
  padding: $spacing-base;
  padding-bottom: 0;
  justify-content: end;

  button {
    height: 25px;
    margin-left: $spacing-base;
    width: 240px;
  }
}


.workout-wizard {
  display: flex;
  flex-direction: row;
  padding: $spacing-base;

  .step {
    gap: 10px;
  }

  .step-1 {
    width: 30%;
    margin-right: $spacing-base;
  }

  .step-2 {
    width: 35%;
    margin-right: $spacing-base;

    .image-row {
      display: flex;
      background: #3D3E53;

      .image-holder {
        flex: 1;
        margin: 12px;

        .image-header {
          display: flex;
          align-content: space-between;
          margin-bottom: $spacing-small;

          p {
            flex: 1;
            color: $sec5;
            font-size: $font-size-base;
            font-weight: normal;
            margin: 0;
          }

          i {
            font-size: $font-size-base;
            color: $sec0;
            font-weight: bold;
          }
        }

        .image-body {
          height: 229px;
          background: $dark;
          overflow: hidden;

          .dropbox {
            width: 100%;
            height: 100%;
          }
        }
      }


    }

    .image-actions {
      padding: 12px 12px 24px 12px;
      display: flex;
      justify-content: end;
      background: #3D3E53;
    }

    .workout-header {
      background: $secondary-grey;
      flex-direction: row;
      display: grid;
      padding: $spacing-base;
      align-items: start;
      grid-template-columns: 2fr 1fr;
      grid-auto-rows: 1fr;

      a {
        i {
          color: $sec0;
          cursor: pointer;
        }
      }

      .left {
        display: flex;
        flex: 2;
        flex-direction: column;
        
        .attribute {
          margin-bottom: $spacing-base;
          flex: 1;
          input {
            width: 100%;
            box-sizing: border-box;
          }
          textarea {
            width: 100%;
            resize: none;
            box-sizing: border-box;
          }
          select {
            width: 100%;
          }
          span {
            display: block;
            color: $sec7;
            font-size: $font-size-base;
            font-weight: bold;
            margin-bottom: $spacing-small / 2;
          }
        }

        .attribute-row {
          display: flex;
          gap: $spacing-base / 2;
        }

        .bottom-row {
          align-items: center;
          .spacer {
            flex: 1; 
          }
          span {
            display: block;
            color: $sec7;
            font-size: $font-size-base;
            font-weight: bold;
            margin-left: $spacing-base;
          }
        }
      }

      .right {
        flex: 1;
        padding: $spacing-base;
        padding-right: 0;
        justify-content: start;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: end;

        img {
          width: 100%;
        }

        i {
          padding: 4px;
          cursor: pointer;
        }

        .spacer {
          flex: 1;
        }

        button {
          width: 100%;
          margin-bottom: 8px;
        }
      }
    }

    .workout-body {
      padding: $spacing-base;
      background: $sec0;
 
      a {
        i {
          color: $sec1;
          cursor: pointer;
        }
      }

      .exercise-search {
        .row {
          display: flex;
          justify-content: space-between;

          p {
            color: $sec5;
            font-weight: bold;
            font-size: 14px;
          }
        }

        .search-box {
          position: relative;
          margin-bottom: 12px;

          input {
            background: $dark;
            width: 100%;
            box-sizing: border-box;
            outline: 0;
          }
          .results {
            position: absolute;
            z-index: 1;
            background: $sec1;
            width: 100%;
            padding: 8px;
            box-sizing: border-box;

            p {
              margin: 0;
              font-size: 14px;
              color: $dark;
              cursor: pointer;
            }
            p:hover {
              opacity: 0.7;
            }
          }
        }
      }

      .exercise-row {
        padding-bottom: $spacing-base;
        h3 {
          padding: 0;
          margin: 0;
          font-weight: 500;
          font-size: 14px;
          color: white;
        }
        
        .details-row {
          display: flex;
          gap: 14px;
          align-items: end;
          .details {
            p {
              font-weight: 500;
              font-size: 14px;
              color: $sec5;
              margin: 4px;
              margin-left: 0;
            }
            input {
              background: $dark;
              width: 60px;
            }
            select {
              background: $dark;
              width: 280px;
            }
          }
          a {
            padding: 10px;
          }
        }
      }
    }
  }

  .workout-row {
    position: relative;
    width: 100%;
    height: 110px;
    display: flex;
    margin-bottom: $spacing-base;
    cursor: pointer;
    background: $wizard-light-background;

    .row-image {
      width: 140px;
      height: 110px;
      background: #000;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .row-details {
      flex: 1;
      height: 110px;
      padding: $spacing-base;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      h3 {
        margin: 0;
        color: #FFF;
        font-size: $font-size-medium;
        font-weight: bold;
      }

      p {
        margin: 0;
        color: $sec5;
        font-size: $font-size-small;
        font-weight: normal;
      }

      .workout-extras {
        display: flex;
        flex: 1;
        justify-content: space-between;
        color: $sec5;
        font-size: $font-size-small;
        font-weight: normal;
        align-items: end;
        text-transform: uppercase;

        span {
          margin-right: $spacing-base;
        }
        
        span:last-of-type {
          flex: 1;
          text-align: right;
          margin-right: 0;
        }
      }
    }

    .pro-triangle {
      right: 0;
      top: 0;
      position: absolute;
    }


    .details {
      background: $sec0;
      flex: 4;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: $spacing-base;

      .top-row {
        display: flex;
        justify-content: space-between;

        .ad-status-holder {
          display: flex;
          align-items: center;
        }

        .status {
          width: 8px;
          height: 8px;
          background: $sec1;
          border-radius: 10px;
          margin-left: 3px;
        }
        .active-ads {
          background: $green2;
        }
      }

      span {
        color: $sec4;
        font-size: $font-size-small;
      }

      h2 {
         padding: 0;
         margin: 0;
         font-size: $font-size-medium;
         color: white;
         font-weight: bold;
      }
    }

    .stats {
      background: $secondary-grey;
      flex: 2;
      padding: $spacing-base;

      .stat-row {
        display: flex;
        justify-content: space-between;
        font-size: $font-size-small;
        color: $sec5;
        margin-bottom: $spacing-small/2;
      }
    }
  }

  #active {
    background: $blue;

    span, h3, p {
      color: #FFF;
    }
  }

}
</style>
